import 'retinajs/dist/retina';
import $ from 'jquery';
import 'particles.js';
import 'docsify-pagination';

import Logger from '../logger';
import l from './lang';

window.l = l;
window.$ = window.jQuery = $;

// webpack-dev-server
if (typeof module !== 'undefined' && module.hot) {
    module.hot.accept();

    if (typeof __webpack_require__ !== 'undefined') {
        __webpack_require__.p = 'http://localhost:8080/';
    }
}

function escapeHTML(text) {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}


$(() => {
    // Burger menu
    $('.nav .burger-menu').on('click', () => {
        $('.nav .pages').toggleClass('unfolded');
    });

    $('.nav .current-lang').on('click', () => {
        $('.lang-dropdown').toggleClass('hidden');
        $('.nav .pages')
            .toggleClass('unfolded')
            .toggleClass('lang-only');
    });

    $('body').on('click', (e) => {
        if (e.target.className !== 'current-lang') {
            $('.lang-dropdown').addClass('hidden');
        }
    });

    // Чтобы не скакала боковая меню при переходах
    $('aside.sidebar').on('scroll', (e) => {
        e.preventDefault();

        if (window.prevScroll !== undefined) {
            $('aside.sidebar')[0].scrollTop = window.prevScroll;
            window.prevScroll = undefined;
        }
    });

    $('body').on('click', 'a', (e) => {
        // Используется чуть выше
        const sidebar = $('aside.sidebar')[0];
        if (sidebar) {
            window.prevScroll = sidebar.scrollTop;
        }

        if (window.location.pathname.indexOf('/docs/v3/') > -1 && ($(e.currentTarget).attr('href') || '').indexOf('/docs/v3/') === -1) {
            e.preventDefault();
            e.stopPropagation();

            if ($(e.currentTarget).attr('target') === '_blank') {
                window.open(e.currentTarget.href);
            } else {
                window.location.href = e.currentTarget.href;
            }
        }
    });

    // Smooth scroll
    $('a[href*="#"]')
        .not('[href="#"]') // Remove links that don't actually link to anything
        .not('[href="#0"]')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
                && location.hostname === this.hostname
            ) {
                // Figure out element to scroll to
                let target = $(this.hash);
                target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({ scrollTop: target.offset().top }, 1000, () => {

                    });
                }
            }
        });

    // Регистрация
    if ($('.signup').length) {
        const validateSignup = () => {
            let hasError = false;

            const showError = ($element, msg) => {
                $element.addClass('error');
                $element.find('.error-msg').text(msg);
                hasError = true;
            };

            $('input, textarea').each((i, input) => {
                let { name, value } = input;
                const $parent = $(input).parent();

                if (name === 'company') {
                    if (value) {
                        $parent.removeClass('error');
                    } else {
                        showError($parent, l('Заполните название вашей компании'));
                    }
                }

                if (name === 'name') {
                    if (value) {
                        $parent.removeClass('error');
                    } else {
                        showError($parent, l('Заполните ваше имя и фамилию'));
                    }
                }

                if (name === 'phone') {
                    value = (value || '').replace(/\(|\)|\s|\-/g, '');

                    if (!value || value.indexOf('+') === -1 || value.length < 6) {
                        showError($parent, l('Телефон должен начинаться с "+" и кода страны'));
                        return;
                    }

                    // Валидация украинских номеров
                    if (value.indexOf('+380') === 0 && value.length !== 13) {
                        showError($parent, l('Телефон должен быть в международном формате и содержать 12 цифр'));
                        return;
                    }

                    // Валидация российских номеров
                    if (value.indexOf('+7') === 0 && value.length !== 12) {
                        showError($parent, l('Телефон должен быть в международном формате и содержать 11 цифр'));
                        return;
                    }

                    if (window.libphonenumber && !window.libphonenumber.parsePhoneNumberFromString(value).isValid()) {
                        showError($parent, l('Неправильный номер телефона. Попробуйте ввести номер в международном формате.'));
                        return;
                    }

                    // Любой другой подошел
                    $parent.removeClass('error');
                }

                if (name === 'email') {
                    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (re.test(value)) {
                        $parent.removeClass('error');
                    } else {
                        showError($parent, l('Неправильный имейл'));
                    }
                }

                if (name === 'pass') {
                    if (value && value.length >= 8) {
                        $parent.removeClass('error');
                    } else {
                        showError($parent, l('Пароль должен сожержать не меньше 8 символов'));
                    }
                }

                if (name === 'about') {
                    if (value && value.length >= 100) {
                        $parent.removeClass('error');
                    } else {
                        showError($parent, l('Текст об интеграции должен быть не меньше двух предложений (100 символов)'));
                    }
                }
            });

            return hasError;
        };

        $('.signup form').on('submit', (e) => {
            const hasError = validateSignup();

            if (hasError) {
                e.preventDefault();
                window.scrollTo(0, 0);

                $('input, textarea').on('keyup', () => {
                    console.log('change event');
                    validateSignup();
                });
            }
        });
    }

    // Страница завершения регистрации, на ней отправляем на бек запрос для создания аккаунта
    if ($('.signup-finish').length) {
        clientForm['lang'] = l();
        $.post('/signup/create-user', clientForm)
            .done((res) => {
                if (res.success) {
                    location.href = res.redirectUrl;
                } else {
                    throw 'Error';
                }
            });
    }


    if ($('.page-hack-space, .page-hack-tarantino').length) {
        const validateSignup = () => {
            console.log('validate');
            let hasError = false;

            const showError = ($element, msg) => {
                $element.addClass('error');
                $element.find('.error-msg').text(msg);
                hasError = true;
            };

            $('input, textarea').each((i, input) => {
                let { name, value } = input;
                const $parent = $(input).parent().parent();

                console.log(name, value);

                if (name === 'name') {
                    if (value) {
                        $parent.removeClass('error');
                    } else {
                        showError($parent, l('Заполните ваше имя и фамилию'));
                    }
                }

                if (name === 'phone') {
                    value = (value || '').replace(/\(|\)|\s|\-/g, '');

                    if (!value || value.indexOf('+') === -1 || value.length < 6) {
                        showError($parent, l('Телефон должен начинаться с "+" и кода страны'));
                        return;
                    }

                    // Валидация украинских номеров
                    if (value.indexOf('+380') === 0 && value.length !== 13) {
                        showError($parent, l('Телефон должен быть в международном формате и содержать 12 цифр'));
                        return;
                    }

                    // Валидация российских номеров
                    if (value.indexOf('+7') === 0 && value.length !== 12) {
                        showError($parent, l('Телефон должен быть в международном формате и содержать 11 цифр'));
                        return;
                    }

                    // Любой другой подошел
                    $parent.removeClass('error');
                }

                if (name === 'email') {
                    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (re.test(value)) {
                        $parent.removeClass('error');
                    } else {
                        showError($parent, l('Неправильный имейл'));
                    }
                }
            });

            return hasError;
        };

        $('.registration form').on('submit', (e) => {
            const hasError = validateSignup();
            if (hasError) {
                e.preventDefault();
                $('input, textarea').on('keyup', () => validateSignup());
            }
        });
    }
});



// WEBPACK FOOTER //
// ./resources/js/site/app.js